import '@adornis/buchungsheld-components/authentication/bh-component-action-otp-login';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-loading-state';
import '@adornis/forms/x-checkbox.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BHRegistrationFlowSubPage } from './bh-page-registration-sub-page.js';

@customElement('bh-page-registration-verify-mail')
export class BHPageRegistrationTerms extends BHRegistrationFlowSubPage {
  override styles() {
    return [
      {
        'ol li': {
          marginBottom: this.spacing.sm,
        },
      },
    ];
  }

  override backAction = () => this._registrationController.previous();
  override nextAction = null;

  override content() {
    const email = this._registrationController.currentUser?.email;
    const institutionID = this._registrationController.institutionID;
    if (!email || !institutionID) return html`<x-loading-state></x-loading-state>`;

    return html`
      <bh-component-action-otp-login
        email=${email}
        institution-id=${institutionID}
        @login=${() => this._registrationController.next()}
      ></bh-component-action-otp-login>
    `;
  }
}
